import script from "./OfferSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferSingle.vue?vue&type=script&setup=true&lang=js"

import "./OfferSingle.vue?vue&type=style&index=0&id=8252be48&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8252be48"]])

export default __exports__